import React from "react";
import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
import { useAuth } from "../context/AuthContext";
import ProductCard from "../components/ProductCard";
import { Heart } from "lucide-react";

export default function Wishlist() {
    const { items } = useWishlist();
    const { user } = useAuth();
    React.useEffect(() => { document.title = "Wishlist | Loomara"; }, []);

    if (!user) {
        return (
            <div className="container-boutique py-24 text-center" data-testid="wishlist-empty-auth">
                <Heart size={36} className="mx-auto text-sage-400" strokeWidth={1.2} />
                <h1 className="font-serif text-4xl text-ink-900 mt-4">Save your favourites</h1>
                <p className="text-ink-500 mt-3">Sign in to keep a private wishlist of pieces you love.</p>
                <Link to="/login" className="btn-primary mt-8 inline-flex">Sign In</Link>
            </div>
        );
    }
    return (
        <div className="container-boutique py-16" data-testid="wishlist-page">
            <p className="eyebrow">My Wishlist</p>
            <h1 className="font-serif text-5xl text-ink-900 mt-3">{items.length === 0 ? "Your wishlist awaits" : "Pieces you love"}</h1>
            {items.length === 0 ? (
                <div className="text-center py-16 text-ink-500">
                    <p>You haven't saved anything yet — tap the heart on any piece.</p>
                    <Link to="/shop" className="btn-primary mt-6 inline-flex">Discover the Collection</Link>
                </div>
            ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-10">
                    {items.map((p, i) => (<ProductCard key={p.id} product={p} index={i} listName="wishlist" />))}
                </div>
            )}
        </div>
    );
}
